import React, { useRef, useState, useEffect } from 'react';
import { useDrag } from 'react-dnd';
import { useQuery, useMutation, useQueryClient } from 'react-query'
import { fetchItem, deleteThing, updateThing } from './queries';


function Item({ id, parent, ...props }) {
    const queryClient = new useQueryClient()
    // const invalSelf = () => queryClient.invalidateQueries(['item', id])
    const updateSelf = (data) => queryClient.setQueryData(['item', id], data)

    const updateAction = useMutation(updateThing, {
        onSuccess: updateSelf,
    })

    const deleteAction = useMutation(deleteThing, {
        onSuccess: () => {
            queryClient.invalidateQueries(['item', parent])
        },
    })

    const { isLoading, error, data } = useQuery(['item', id], () => fetchItem(id))

    const [{ isDragging }, drag, dragPreview] = useDrag(() => ({
        type: 'ITEM',
        item: { id },
        end: (item, monitor) => {
            const dropResult = monitor.getDropResult()
            if (item && dropResult) {
                alert(`You dropped ${item.id} into ${dropResult.name}!`)
            }
        },
        collect: (monitor) => ({
            isDragging: monitor.isDragging()
        })
    }))

    const [description, setDescription] = useState("dads")

    if (isLoading) return <div className='item'>Loading...</div>

    if (error) return <div className='item'>Error: {error.message}</div>

    //setDescription(data.description)

    function updateText(text) {
        updateAction.mutate({
            id: id, data: { description: text }
        })
    }

    let textChangedTimeout
    function textChangedEvent(event) {
        setDescription(event.target.value)
        if (textChangedTimeout)
            clearTimeout(textChangedTimeout)
        textChangedTimeout = setTimeout(updateText, 3000, event.target.value)
    }


    return (
        <div className='item-holder' ref={dragPreview} style={{ opacity: isDragging ? 0.5 : 1 }}>
            <input ref={drag} className='item' type='text' onChange={textChangedEvent} value={description}></input>
        </div>
    )
}

export default Item